import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Moderne priredbe",
  "description": "",
  "published": "2007-07-13T00:00:00.000Z",
  "redirect_from": ["/blog/moderne-priredbe/swizec/171"],
  "categories": "video",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`SinoÄi sem se sreÄal s še eno odliÄno pesmijo za katero se je izkazalo, da je v resnici priredba pesmi iz 80-ih, electropop, synthpop, electronica ali katerikoli Å¾anr je Å¾e paÄ bil ... preveÄ preveÄ podobnih Å¾anrov v 80-ih, zelo nadleÅ¾no.`}</p>
    <p>{`Kar se mi zdi Äudno je, da vse moderne priredbe electropop pesmi, ki jih najdem, zvenijo neizmerno bolje od original, za razliko od rock priredb, ki so ponavadi slabše kvalitete in jim manjka neko Äustvo.`}</p>
    <p>{`Vzamimo za primer `}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=OufZbzsUtIo"
      }}>{`Sweet Dreams banda Eurhythmics`}</a>{`, prav fajn pesem, dober zven, ampak neskonÄno nadleÅ¾na v svoji izvedbi. Sedaj pa poglejmo `}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=3iuve2OjY_8"
      }}>{`Marylin Mansonovo izvedbo`}</a>{` in opazimo, da vsebuje veliko veÄji obÄutek, zveni bolje in preprosto bolj pristoji besedilu. `}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=4NAPw8N5vM8"
      }}>{`Fear for Tears - Mad World`}</a>{` je podoben primer, v originalu popolnoma neprimerna za besedilo in deluje skoraj kot parodija, medtem ko `}<a parentName="p" {...{
        "href": "http://youtube.com/watch?v=v52Igdotisk"
      }}>{`Gary Jules/Michael Andrews priredba`}</a>{` odliÄno pristoji besedilu, poÄasno depresivna in preprosto odliÄna.`}</p>
    <p>{`Najzanimivejša razlika, ki jo opaÅ¾am je, da moderne priredbe praviloma zmanjšajo tempo originala, uporabijo globlji bolj Äustven glas in veliko preprostejšo glasbeno ozadje. Se tako moÄno spreminjajo le Äasi ali se globalno spreminja glasbeni okus poslušalcev, ali pa je electropop preprosto slaba glasba?`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      